import { render } from "./getAutoPrescription.vue?vue&type=template&id=375bb236&scoped=true"
import script from "./getAutoPrescription.vue?vue&type=script&lang=js"
export * from "./getAutoPrescription.vue?vue&type=script&lang=js"

import "./getAutoPrescription.vue?vue&type=style&index=0&id=375bb236&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375bb236"]])

export default __exports__